export const firebaseKeys = {
  all: ['firebase'] as const,
  collections: (connectionId: string) =>
    [...firebaseKeys.all, 'collections', connectionId] as const,
  documentsInfinite: (connectionId: string, collectionPath: string, sortKey: string) =>
    [...firebaseKeys.all, 'documentsInfinite', connectionId, collectionPath, sortKey] as const,
  /** Prefix key for invalidating all documentsInfinite queries for a collection */
  documentsInfinitePrefix: (connectionId: string, collectionPath: string) =>
    [...firebaseKeys.all, 'documentsInfinite', connectionId, collectionPath] as const,
  document: (connectionId: string, collectionPath: string, documentId: string) =>
    [...firebaseKeys.all, 'document', connectionId, collectionPath, documentId] as const,
  subcollections: (connectionId: string, documentPath: string) =>
    [...firebaseKeys.all, 'subcollections', connectionId, documentPath] as const,
  search: (connectionId: string, collectionPath: string, q: string, limit: number) =>
    [...firebaseKeys.all, 'search', connectionId, collectionPath, q, limit] as const,
};
